@import "../../../styles/variables";
:host {
  display: block;
}

.offsites-widget {
  position: relative;
  display: none;
}

.offsites-widget.default {
  display: block;
}

.offsites-widget > a {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.uiaas-offsites-widget {
  height: 116px;
  background: transparent no-repeat top center;
  background-size: cover;
  position: relative;
  cursor: pointer;
  pointer-events: none;
}

.uiaas-offsites-widget.type-above {
  width: 1145px;
  height: 175px;
}

.uiaas-offsites-widget.type-result-like {
  margin: 0;
}

@media (min-width: 1200px) {
  .offsites-widget {
    display: block;
    height: 100%;
  }
}

a {
  color: #42b4e6;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.contents {
  position: absolute;
  top: 0;
}

.contents {
  ul {
    list-style: none;
    padding: 0;
    position: relative;
    top: 58px;
    left: 42px;
    font-size: 14px;
  }

  li {
    display: block;
    padding: 3px 0;
  }
}

.offsites-widget__offset {
  padding-bottom: 20px;
  overflow: hidden;
}

.media,
.apc,
.aveva,
.default {
  .uiaas-offsites-widget,
  .offsites-widget-default--large {
    background-position: center center;
    background-size: cover;
  }

  .uiaas-offsites-widget {
    height: 245px;
  }

  .contents {
    top: 106px;
    left: 35px;

    ul {
      top: 0;
      left: 0;
    }
  }

  .logo {
    position: absolute;
    top: 42px;
    left: 18px;
    width: 195px;
  }

  .product-image__container {
    pointer-events: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 420px;
    width: 460px;

    .product-image__image {
      display: block;
      position: absolute;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top left;
      top: 33px;
      width: 140px;
      left: 50%;
      margin-left: -70px;
      height: 200px;

      .shadow {
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: top left;
        top: 136px;
        left: -49px;
        width: 240px;
        height: 85px;
      }
    }
  }
}

.offsites-widget__url {
  text-decoration: none;
  color: unset;

  @media (min-width: $uiaas-tablet) {
    display: grid;
  }
}

.offsites-widget-default {
  padding: 20px;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position-x: right;
  background-size: contain;
  box-shadow:
    0px 0px 2px rgba(51, 51, 51, 0.05),
    0px 2px 10px rgba(51, 51, 51, 0.15);
  &:hover {
    box-shadow:
      0px 0px 10px rgba(51, 51, 51, 0.05),
      0px 10px 15px rgba(51, 51, 51, 0.15);
  }
}

.offsites-widget-default-dashboard {
  @extend .offsites-widget-default;
  min-height: 144px;

  &--without-or-single-link {
    @media (min-width: $uiaas-tablet) {
      display: flex;
      height: calc(100% - 40px);
      flex-direction: column;
      justify-content: space-between;
    }
  }
}

a.offsites-widget__url {
  text-decoration: none;
  height: 100%;
}

.offsites-title {
  margin: 0;
}

.offsites-title__value {
  font-size: 24px;
  line-height: 34px;
  &:hover {
    text-decoration: none;
    text-underline: none;
  }
}

.offsites-title__value-colored {
  @extend .offsites-title__value;
  color: var(--qds-theme-signature-color-default, #008a16);
}

.offsites-subtitle {
  font-size: 14px;
  line-height: 25px;
  margin: 8px 0 0 0;
  white-space: pre-wrap;
}

.offites-list {
  list-style: none;
  margin: 0;
  padding: 14px 0 0 0;
}

.offistes-list-element {
  margin-top: 12px;
}

.offsites-link-section {
  display: flex;
  flex-direction: column;
  @media (min-width: $uiaas-tablet) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
  }
}

// Combinations

.media {
  margin-right: 20px;

  .uiaas-offsites-widget {
    margin-right: 0;
  }

  .contents {
    top: 50px;

    .offsites-title,
    .offsites-subtitle {
      color: white;
      font-size: 24px;
    }

    .offsites-subtitle {
      font-size: 18px;
    }
  }

  button {
    bottom: 52px;
    left: 320px;
    margin-left: 53%;
    position: relative;
  }
}

.offsites-widget-default--large {
  height: 205px;

  .offsites-title {
    margin-top: 13px;
  }

  .offsites-link-section {
    bottom: 35px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 93%;
  }
}

.offsites-widget-default--alternative {
  color: $svs-white;

  .offsites-link {
    color: $svs-light-sky-blue;
  }
}

.offsites-widget.aveva {
  display: block;
  background-color: $svs-white;
  height: 100%;

  &:hover,
  &:focus {
    button {
      background-color: #353333;
    }
  }

  .offsites-widget__url {
    display: flex;
  }

  .uiaas-offsites-widget {
    background-size: cover;
    display: flex;
    flex: 1;
    flex-direction: column;
    height: auto;
    justify-content: space-between;
    padding: 20px;

    div {
      display: flex;
      justify-content: flex-end;
    }
  }

  .offsites-title__value-colored {
    color: #ffdc19;
  }

  .offsites-subtitle {
    color: $svs-white;
    width: 50%;

    @media (max-width: $uiaas-tablet) {
      display: block;
      margin-bottom: 10px;
    }
  }

  button {
    // Can not use qds-button here because of different styles (color, background-color)
    background-color: $svs-black;
    border: unset;
    border-radius: 4px;
    color: #ffdc19;
    cursor: pointer;
    font-size: 16px;
    line-height: 24px;
    padding: 5px 24px;
  }
}

.offsites-widget-default--alternative-half-width-subtitle {
  .offsites-subtitle {
    width: 50%;
  }

  .offsites-link {
    filter: brightness(120%);
    font-weight: 600;
  }

  .offsites-title {
    margin-top: 0;
  }
}

.offsites-widget-default--only-image {
  .offsites-link-section {
    bottom: 23px;
    width: 95.5%;
  }
}
